// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-ok[data-v-540f8cca] {\n    width: 70px;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
